import {
 faDotCircle, faArrowAltSquareDown, faArrowAltSquareUp, faTrashAlt
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Grid, Tooltip, Typography, Box
} from '@mui/material';
import { DeleteButton } from 'components/_commons';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'components/_commons/GenericTable/GenericTable';
import { translate } from 'utils';
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';

const StyledGridItem = styled(Grid)(({ theme, color }) => ({
  backgroundColor: color,
  paddingLeft: 10,
  width: '100%',
  margin: '1px 0px',
  opacity: 1,
  visibility: 'visible',
  display: 'flex'
}));

const StyledTypography = styled(Typography)(() => ({
  color: 'rgba(0, 0, 0, 0.87)',
  opacity: 1,
  fontWeight: 400,
  display: 'block'
}));

const TooltipWrapper = React.forwardRef(({ children, ...props }, ref) => React.cloneElement(children, {
    ref,
    ...props
  }));

export const CustomListItem = observer(({
                                          startIcon, tagIcon1, tagIcon2, isMovableUp, isMovableDown, onMoveItemUp, onMoveItemDown, title, onDelete, isItemColorChanged
                                        }) => {
  const [itemColor, setItemColor] = useState('var(--grey-lighter)');

  useEffect(() => {
    setItemColor(isItemColorChanged ? 'var(--error-color-lighter)' : 'var(--grey-lighter)');
  }, [isItemColorChanged]);

  return (
    <Grid container direction="column" wrap="nowrap">
      <StyledGridItem color={itemColor} item>
        <Grid alignItems="center" container direction="row" spacing={2} wrap="nowrap">
          <Grid item>
            <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: 'rgba(0, 0, 0, 0.6)',
                    minWidth: 20
                  }}
              >
              {startIcon || (
                <svg
                        aria-hidden="true"
                        className="svg-inline--fa fa-dot-circle fa-xs"
                        data-icon="dot-circle"
                        data-prefix="far"
                        focusable="false"
                        role="img"
                        style={{ width: '0.75em', height: '0.75em' }}
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                  <path
                          d="M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
                          fill="currentColor"
                      />
                </svg>
                )}
            </Box>
          </Grid>

          <Grid item xs>
            <StyledTypography>{title}</StyledTypography>
          </Grid>

          <Grid item>
            <Grid
                  alignItems="center"
                  container
                  justifyContent="flex-end"
                  spacing={1}
                  sx={{ display: 'flex', visibility: 'visible', opacity: 1 }}
              >
              {tagIcon1 !== null && (
                <Grid item sx={{ display: 'flex', visibility: 'visible', opacity: 1 }}>
                  {tagIcon1}
                </Grid>
                )}
              {tagIcon2 !== null && (
                <Grid item sx={{ display: 'flex', visibility: 'visible', opacity: 1 }}>
                  {tagIcon2}
                </Grid>
                )}
              {isMovableDown && (
                <Grid item>
                  <Tooltip title={translate('button.moveDown')}>
                    <TooltipWrapper>
                      <PrimaryButton onClick={onMoveItemDown}>
                        <FontAwesomeIcon icon={faArrowAltSquareDown} size="xs" />
                      </PrimaryButton>
                    </TooltipWrapper>
                  </Tooltip>
                </Grid>
                )}
              {isMovableUp && (
                <Grid item>
                  <Tooltip title={translate('button.moveUp')}>
                    <TooltipWrapper>
                      <PrimaryButton onClick={onMoveItemUp}>
                        <FontAwesomeIcon icon={faArrowAltSquareUp} size="xs" />
                      </PrimaryButton>
                    </TooltipWrapper>
                  </Tooltip>
                </Grid>
                )}
              <Grid item>
                <DeleteButton onClick={onDelete}>
                  <FontAwesomeIcon icon={faTrashAlt} size="xs" />
                </DeleteButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </StyledGridItem>
    </Grid>
  );
});

CustomListItem.propTypes = {
  startIcon: PropTypes.node,
  tagIcon1: PropTypes.node,
  tagIcon2: PropTypes.node,
  isMovableUp: PropTypes.bool,
  isMovableDown: PropTypes.bool,
  isItemColorChanged: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onMoveItemUp: PropTypes.func,
  onMoveItemDown: PropTypes.func
};

CustomListItem.defaultProps = {
  isItemColorChanged: false,
  isMovableDown: false,
  isMovableUp: false,
  onMoveItemDown: () => {},
  onMoveItemUp: () => {},
  startIcon: null,
  tagIcon1: null,
  tagIcon2: null
};
